import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { fetchHistoryBillings } from '../api/parking-billing.ts';
import { ParkingBilling } from '../models/parkingBilling.ts';
import { HistoryParkingBillingRequest } from '../api/requests/history-parking-billing-request.ts';
import { set, subMonths, subYears } from 'date-fns';

export default function useHistoryBillings(
  period: 'LAST_1_MONTH' | 'LAST_3_MONTHS' | 'LAST_6_MONTHS' | 'LAST_1_YEAR',
): UseQueryResult<ParkingBilling[], Error> {
  const { start, end } = getDateRangeISO(period);
  const request: HistoryParkingBillingRequest = {
    billDateTimeRangeFrom: start,
    billDateTimeRangeTo: end,
  };
  return useQuery({
    queryKey: ['historyBillings', request],
    queryFn: () => fetchHistoryBillings(request),
  });
}

function getDateRangeISO(option) {
  const now = new Date();

  // 設定 end 為當天 23:59:59.999
  const endDate = set(now, {
    hours: 23,
    minutes: 59,
    seconds: 59,
    milliseconds: 999,
  });

  // 根據選項減去月份或年份
  let baseDate;
  switch (option) {
    case 'LAST_1_MONTH':
      baseDate = subMonths(now, 1);
      break;
    case 'LAST_3_MONTHS':
      baseDate = subMonths(now, 3);
      break;
    case 'LAST_6_MONTHS':
      baseDate = subMonths(now, 6);
      break;
    case 'LAST_1_YEAR':
      baseDate = subYears(now, 1);
      break;
    default:
      throw new Error('Unknown date range option');
  }

  // 設定 start 為該天 00:00:00.000
  const startDate = set(baseDate, {
    hours: 0,
    minutes: 0,
    seconds: 0,
    milliseconds: 0,
  });

  // 回傳 ISO 格式字串
  return {
    start: startDate.toISOString(),
    end: endDate.toISOString(),
  };
}
